import { useMutation as e } from "@maat/store-hooks";
import { aiApi as t } from "@maat/api-ai";
//#region src/ai/useAiGenerateMutation.ts
var n = () => e({ mutationFn: ({ promptType: e, payload: n }) => t.generate(e, n) });
//#endregion
export { n as useAiGenerateMutation };
